import { useState } from "react";
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";
import i18n from "../../../i18n-config";
import {
  CustomTableFooter,
  SvgContainer,
} from "../../../components";
import { SORT } from "../../../assets/icons";
import MesAffaireTableRow from "./MesAffaireTableRow";

const style = {
  fontSize: 14,
  color: theme.colors.black,
  fontWeight: 550,
};

const MenuProps = {
  PaperProps: {
    style: {
      paddingRight: 20,
    },
  },
};

interface Props {
  data: any;
  onBlock?: (item: any) => void;
}

function MesAffaireTable({ data, onBlock }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [show, setShow] = useState(false);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleShowOpen = () => setShow((prev) => !prev);

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ mb: 2, boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)" }}
    >
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ bgcolor: "#fff" }}>
            <TableCell sx={style}>
              <Typography>#</Typography>
            </TableCell>
            <TableCell sx={style}>
              {
                <Stack direction={"row"} alignItems="center">
                  <Typography mr={1}>
                    {capitalizeFirstLetter(i18n.t("nom_bara"))}
                  </Typography>
                  <IconButton sx={{ width: 30, height: 30 }}>
                    <SvgContainer
                      svg={SORT}
                      width={15}
                      color={theme.colors.black}
                    />
                  </IconButton>
                </Stack>
              }
            </TableCell>
            <TableCell sx={style}>
              <Typography>
                {capitalizeFirstLetter(i18n.t("nom_boss"))}
              </Typography>
            </TableCell>
            <TableCell sx={style}>
              <Typography>
                {capitalizeFirstLetter(i18n.t("categorie_souscat"))}
              </Typography>
            </TableCell>
            <TableCell sx={style}>
              {
                <Stack direction={"row"} alignItems="center">
                  <Typography mr={1}>
                    {capitalizeFirstLetter(i18n.t("statut"))}
                  </Typography>
                  <IconButton sx={{ width: 30, height: 30 }}>
                    <SvgContainer
                      svg={SORT}
                      width={15}
                      color={theme.colors.black}
                    />
                  </IconButton>
                </Stack>
              }
            </TableCell>
            <TableCell sx={style}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : data
          ).map((item: any, index: any) => (
           <MesAffaireTableRow item={item} key={index} />
          ))}
        </TableBody>
        <CustomTableFooter
          rowsPerPage={rowsPerPage}
          data={data}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Table>
    </TableContainer>
  );
}

export default MesAffaireTable;
